import React, { useEffect } from 'react';
import { LoadingButton, Stack } from '@talentmesh/core';
import { useTheme } from '@mui/material/styles';
import { useWatch } from 'react-hook-form';
import { useAssessmentActionsContext } from '../../../Context/AssessmentActionsContext';
import useTMTranslation from '../../../Hooks/useTMTranslation';
import { useCTMonitoringFormContext } from '../../../Models/CandidateTestMonitoringSettings';

function AcceptRulesPanel(): React.JSX.Element {
    const theme = useTheme();
    const { tTest } = useTMTranslation();
    const { control, setValue } = useCTMonitoringFormContext();
    const { activeAssessmentId } = useAssessmentActionsContext();

    const terms = useWatch({ control, name: 'termsAccepted' });

    useEffect(() => {
        setValue('termsAccepted', true);
    }, []);

    return (
        <Stack direction="column" spacing={theme.spacing(3)} alignItems="center">
            <LoadingButton
                variant="contained"
                size="large"
                type="submit"
                disabled={!terms}
                loading={activeAssessmentId !== ''}
            >
                {tTest('StartTest')}
            </LoadingButton>
        </Stack>
    );
}

export default AcceptRulesPanel;
